
import React from 'react';
import Icon from './index';

const vectors = 'M20 22H4a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h4V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM14 8h-4v12h4V8zm-6 4H4v8h4v-8zm8-8v16h4V4h-4z';

export default function GraphBar(props) {
  return (
    <Icon {...props} viewBox="0 0 24 24" vectors={vectors} />
  );
}

